module.exports = __webpack_public_path__ + "img/small-ship-wreck-h.45107a9b.png";